<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="active" @tab-click="tabClick" v-if="showTabs">
          <el-tab-pane label="装修成本" name="renovate">
            <fee ref="renovate" :house-id="houseId" :type="0" :houses="houses" :rent-records="rentRecords"></fee>
          </el-tab-pane>
<!--          <el-tab-pane label="水费" name="electric">-->
<!--            <fee ref="electric" :house-id="houseId" :type="1" :houses="houses" :rent-records="rentRecords"></fee>-->
<!--          </el-tab-pane>-->
<!--          <el-tab-pane label="电费" name="water" >-->
<!--            <fee ref="water" :house-id="houseId" :type="2" :houses="houses" :rent-records="rentRecords"></fee>-->
<!--          </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>

import Fee from "@/components/Fee";
import {getList as getHouses} from "@/api/house";
import {getList as getRentRecords} from "@/api/rentRecord";

export default {
  components: {
    Fee
  },
  data() {
    return {
      active: 'renovate',
      houseId: 0,
      houses: [],
      rentRecords: [],
      showTabs: false
    }
  },
  mounted() {
    this.houseId = parseInt(this.$route.query.houseId)
    setTimeout(() => {
      this.showTabs = true
    }, 100);
    this.getHouses()
    this.getRentRecords()
  },
  methods: {
    getHouses() {
      getHouses().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.houses = response.data
        }
      })
    },
    getRentRecords() {
      const params = {
        houseId: this.houseId
      }
      getRentRecords(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.rentRecords = response.data
        }
      })
    },
    tabClick() {
      const tab = this.active
      if (tab == 'renovate') {
        this.$refs['renovate'].search(true)
      } else if (tab == 'electric') {
        this.$refs['electric'].search(true)
      } else if (tab == 'water') {
        this.$refs['water'].search(true)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/feeDetail.vue